export const HowItWorks = () => (
  <div className="min-h-screen bg-white py-16">
    <div className="max-w-4xl mx-auto px-6">
      <h1 className="text-4xl font-semibold text-[#1A1A1A] mb-8 font-['Outfit']" data-testid="how-it-works-title">How It Works</h1>
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-medium text-[#005B99] mb-4 font-['Outfit']">For Guests</h2>
          <ol className="list-decimal list-inside space-y-2 text-[#6B7280]">
            <li>Search Cape Town properties</li>
            <li>View verified listings with photos and details</li>
            <li>Contact property owners directly</li>
            <li>Arrange payment and lease agreement privately</li>
          </ol>
        </section>
        <section>
          <h2 className="text-2xl font-medium text-[#005B99] mb-4 font-['Outfit']">For Hosts</h2>
          <ol className="list-decimal list-inside space-y-2 text-[#6B7280]">
            <li>Create a host account</li>
            <li>Pay the R950 listing fee (valid for 3 months)</li>
            <li>Upload property photos and verification video</li>
            <li>Wait for admin approval (within 24 hours)</li>
            <li>Receive direct enquiries from guests</li>
          </ol>
        </section>
      </div>
    </div>
  </div>
);
